export const openFilters = () => ({ type: "OPEN_FILTERS" });
export const closeFilters = () => ({ type: "CLOSE_FILTERS" });
